import {
  PrefilledMessages,
  SHOW_SUPPORT_GET_PARAM,
} from '../../services/SupportChatService/constants';
import { HelpCrunchService } from '../../services/HelpCrunchService';
import { useHelpCrunchIsReady } from './useHelpCrunchIsReady';

export const useCheckUrl = () => {
  const isReady = useHelpCrunchIsReady();
  const currentUrl = new URL(window.location.href);
  const contactSupport = currentUrl.searchParams.get(SHOW_SUPPORT_GET_PARAM);
  const message = PrefilledMessages[contactSupport] || '';
  if (currentUrl.searchParams && contactSupport && isReady) {
    HelpCrunchService.openChat();
    HelpCrunchService.enterText(message);
  }

  return null;
};
